var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUTurn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6E625E;stroke:#FAF9F7;stroke-width:1.5;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.9,29.6v43.9H50.2V30.1c0-4-2.4-7.4-5.9-8.7c-0.5-0.2-1-0.4-1.6-0.5c0,0-0.1,0-0.2,0 c-0.6-0.1-1.2-0.2-1.8-0.2c-3.2,0-6.1,1.6-7.8,4.1c-0.1,0.1-0.2,0.3-0.3,0.5s-0.3,0.4-0.4,0.7c-0.1,0.2-0.2,0.5-0.3,0.7 c-0.1,0.2-0.2,0.5-0.3,0.7c-0.3,0.9-0.5,1.9-0.5,2.9v32.3l4.4-0.1l-4.4,4.4l-6.9,6.9l-11-11l4.1-0.1V29.6c0-0.4,0-0.9,0-1.3 c0.2-3.3,1.1-6.5,2.6-9.3C23.2,12.5,29.5,7.8,37,6.7c0.4,0,0.8-0.1,1.2-0.1c0.3,0,0.7-0.1,1-0.1c0.5,0,0.9,0,1.4,0 c0.9,0,1.8,0,2.7,0.2c0.9,0.1,1.9,0.3,2.8,0.5c2.6,0.6,5,1.7,7.2,3.1c1.4,0.9,2.6,1.9,3.8,3c0.2,0.2,0.5,0.5,0.7,0.8 c0.2,0.2,0.5,0.5,0.7,0.8c0.3,0.4,0.7,0.8,1,1.3c0.1,0.2,0.2,0.4,0.4,0.5c0.6,0.8,1.1,1.7,1.5,2.6c0.2,0.3,0.3,0.6,0.5,1 s0.4,0.9,0.5,1.3c0.3,0.8,0.6,1.6,0.8,2.4l0,0c0.2,0.6,0.3,1.3,0.4,1.9C63.8,27.1,63.9,28.3,63.9,29.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-44.7,37.8l-1.7-3.8c-0.7-1.5-2.4-2.1-3.9-1.5l-0.4,0.2l2.4,5.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUTurn);
export default __webpack_public_path__ + "static/media/arrow-u-turn.e97f1e5d631eb9c0ae5b84ced68e4aa4.svg";
export { ForwardRef as ReactComponent };